import styled from "styled-components";

export const CalendarHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
`;

export const CalendarHeaderNavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CalendarHeaderViewToggle = styled.div`
  display: flex;
  align-items: center;
`;

export const CalendarHeaderTitle = styled.h1`
  font-size: 24px;
  line-height: 36px;
  margin: 0 16px;
`;

export const CalendarContainer = styled.div`
  .fc {
    width: 100%;
    height: 100%;
    font-size: 14px;
    --fc-today-bg-color: ${(props) => props.$primaryLight};
    --fc-event-bg-color: ${(props) => props.$primary};
    --fc-event-border-color: ${(props) => props.$primary};

    --fc-button-text-color: ${(props) => props.$primary};
    --fc-button-bg-color: #fff;
    --fc-button-border-color: ${(props) => props.$primary};
    --fc-button-hover-bg-color: ${(props) => props.$primaryLight};
    --fc-button-hover-border-color: ${(props) => props.$primaryLight};
    --fc-button-active-bg-color: ${(props) => props.$primaryLight};
    --fc-button-active-border-color: ${(props) => props.$primary};
    --fc-small-font-size: 12px;

    .fc-dayGridMonth-view {
      overflow: auto;
    }

    .fc-dayGridMonth-view .fc-scrollgrid {
      min-width: 570px;
    }

    .fc-timeGridWeek-view {
      overflow: auto;
    }

    .fc-timeGridWeek-view .fc-scrollgrid {
      min-width: 570px;
    }

    .fc-timeGridDay-view {
      --fc-today-bg-color: #fff;
    }
    .fc-scrollgrid {
      border-radius: 6px;
    }

    .fc-scrollgrid-section-header .fc-timegrid-axis {
      padding: 8px 15px;
      box-sizing: border-box;
    }
    .fc-col-header {
      background-color: #F7F7FA;
    }

    .fc-col-header .fc-col-header-cell {
      padding: 8px 15px;
      line-height: 20px;
    }

    .fc-timegrid-slot {
      height: 5em;
    }
    .fc-event {
      overflow: hidden;
    }
    .fc-event-main {
      padding: 1px 4px 0;
    }
    .fc-event-time {
      text-overflow: ellipsis;
    }
    .fc-event-title {
      text-overflow: ellipsis;
    }
  }
`;
